import { useEffect, useRef, useState } from 'react'

// Whether something arrived below the fold while the user was reading further
// up. Reaching the bottom again, by the pill or by scrolling, clears it.
export const useNewReplyBelow = (
  isAwayFromBottom: boolean,
  entryCount: number,
) => {
  const [hasNewReply, setHasNewReply] = useState(false)
  const entriesWhenLastAtBottom = useRef(entryCount)

  useEffect(() => {
    if (!isAwayFromBottom) {
      entriesWhenLastAtBottom.current = entryCount
      setHasNewReply(false)
      return
    }
    if (entryCount > entriesWhenLastAtBottom.current) setHasNewReply(true)
  }, [isAwayFromBottom, entryCount])

  return hasNewReply
}
